export type RegisterForm = {
    name: string,
    email: string, 
    phone: string,
}

type DayMonth = {
    day: number,
    month: number
}

export type AllLevels = {
    default: LevelsInfoDetails,
    advanced: LevelsInfoDetails,
    premium: LevelsInfoDetails,
}

export type LevelsInfoDetails = {
    transfer?: DayMonth,
    card?: DayMonth,
    p2p?: DayMonth
}

export const LevelInfoDetailsArray = {
    default: {
        transfer: { day: 1000, month: 1000 },
        card: { day: 1000, month: 1000 },
        p2p: { day: 1000, month: 1000 }
    },
    advanced: {
        transfer: { day: 10000, month: 10000 },
        card: { day: 10000, month: 10000 },
        p2p: { day: 10000, month: 10000 }
    },
    premium: {
        transfer: { day: 100000, month: 100000 },
        card: { day: 100000, month: 100000 },
        p2p: { day: 100000, month: 100000 }
    }
}

export type LoginResponse = {
    code: number,
    data: {
        user_id: string,
        token: string,
        refresh_token: string
    }
}

export const RegisterPhrases = {
    isLogin: {
        title: "Seja bem vindo de volta",
        change: "Não está cadastrado? faça o registro! ",
        helper: "Por favor realize o login para ter acesso a conta"
    },
    isRegister: {
        title: "Registro de carteira",
        change: "Já está cadastrado? faça login! ",
        helper: "Por favor registre uma carteira para começar! A hash sera o seu login e a carteira principal de recebimento dos pagamentos."
    },
    isFromMetamask: {
        title: "Registro de conta",
        change: "Já está cadastrado? faça login! ",
        helper: "Por favor coloque um apelido para essa conta/carteira."
    },
    button: {
        isRegister: "Cadastrar-se",
        isLogin: "Logar-se"
    }
}

export const listNetworks = [
    { name: "Ethereum", tag: 'ETH' },
    { name: "Tron network", tag: 'TRX' },
]